import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import UserPopup from '@components/Popup/UserPopup'
import { Layout, PageHeader, Button, Icon } from 'antd'
import { users } from '@services/api'

import List from './List'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class Users extends Component<any> {
    state = {
        list: [],
        loading: true
    }

    componentDidMount() {
        this.updateUsersList()
    }

    handleAddUser = e => {
        e.preventDefault()
        this.props.popupStore.togglePopup('addUser')
    }

    async updateUsersList() {
        this.state.loading = true

        const usersList = await users.getUsersList()

        this.setState({ list: usersList.data, loading: false })
    }

    render() {
        const { roles } = this.props.authStore

        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="רשימת משתמשים"
                    subTitle="תצוגת כל המשתמשים במערכת"
                >
                    {!(roles.includes('viewer') || roles.includes('editor')) && (
                        <Button style={{ fontSize: '1rem' }} onClick={this.handleAddUser}>
                            <Icon type="plus" /> הוסף משתמש
                        </Button>
                    )}
                </PageHeader>
                <List list={this.state.list} loading={this.state.loading} />
                <UserPopup popupUpdated={() => this.updateUsersList()} />
            </Layout>
        )
    }
}
